import { useLocation } from 'react-router-dom';

import Sidebar from './Sidebar';
import Header from './Header';
import MobileBottomNavigation from './MobileBottomNavigation';
import FeedbackWidget from '../feedback/FeedbackWidget';
import PresenceTracker from '../presence/PresenceTracker';

const Layout = ({ children }) => {
  const location = useLocation();
  const isDashboard = location.pathname === '/dashboard';

  return (
    <div className="server-app-shell flex h-screen h-[100dvh] overflow-hidden">
      <PresenceTracker />
      <Sidebar />

      <div className="relative flex min-w-0 flex-1 flex-col overflow-hidden">
        <Header />

        <main className={`server-page-scroll flex-1 overflow-x-hidden overflow-y-auto ${isDashboard ? 'server-dashboard-canvas' : 'bg-[var(--sisdp-color-canvas)]'}`}>
          <div className="server-page-container">
            {children}
          </div>
        </main>

        <MobileBottomNavigation />
      </div>

      <FeedbackWidget />
    </div>
  );
};

export default Layout;
